import { client } from "@/http/client"

import { IPagingResponse, IRequestParams, IResponse } from "@/types/api"
import { IDownloadDocument } from "@/types/IDownloadDocument"
import {
  IQualityPassport,
  IQualityPassportCreate,
  IQualityPassportUpdate,
  IUploadQualityPassportScansRequest
} from "@/types/IQualityPassport"


export const getQualityPassports = (params: IRequestParams): Promise<IPagingResponse<IQualityPassport>> =>
  client.get("QualityPassports", {
    params
  })

export const getQualityPassportById = (id: number): Promise<IResponse<IQualityPassport>> =>
  client.get(`QualityPassports/${id}`)

export const getQualityPassportScans = (id: number)
  : Promise<IResponse<IDownloadDocument[]>> => client.get(`QualityPassports/Scans/${id}`)

export const createQualityPassport = (
  body: IQualityPassportCreate
): Promise<IResponse<number>> => client.post("QualityPassports", body)

export const updateQualityPassport = (
  body: IQualityPassportUpdate
): Promise<IResponse<number>> => client.patch("QualityPassports", body)

export const archiveQualityPassport = (
  ids: number[]
): Promise<IResponse<number>> => client.delete("QualityPassports/Archive", {
  data: {
    ids
  }
})

export const uploadQualityPassportScans = (body: IUploadQualityPassportScansRequest): Promise<IResponse<never>> =>
  client.post("/QualityPassports/scans", body)